import React from "react";
import like from "../../assets/images/like.svg";
import unlike from "../../assets/images/unlike.svg";

import { useDispatch } from "react-redux";
import { fetchLike, fetchUnlike } from "../../features/video/videoSlice";

const LikeUnlike = ({ likes, unlikes, id }) => {
  const dispatch = useDispatch();

  const handleLike = (id, likes) => {
    dispatch(fetchLike({ id, likes }));
  };

  const handleUnlike = (id, unlikes) => {
    dispatch(fetchUnlike({ id, unlikes }));
  };
  return (
    <div className='flex gap-10 w-48'>
      <div className='flex gap-1'>
        <div onClick={() => handleLike(id, likes)} className='shrink-0 cursor-pointer'>
          <img className='w-5 block' src={like} alt='Like' />
        </div>
        <div className='text-sm leading-[1.7142857] text-slate-600'>{likes}</div>
      </div>
      <div className='flex gap-1'>
        <div onClick={() => handleUnlike(id, unlikes)} className='shrink-0 cursor-pointer'>
          <img className='w-5 block' src={unlike} alt='Unlike' />
        </div>
        <div className='text-sm leading-[1.7142857] text-slate-600'>{unlikes}</div>
      </div>
    </div>
  );
};

export default LikeUnlike;
